import React from "react";
import { Textfit } from "react-textfit";

import "../../css/HeaderCard.css";

function HeaderCard({
  entityData,
  empName,
  paragraph,
  isEntity = false,
  isEmp = false,
}) {
  return (
    <div>
      <div className="backgroundImage"></div>

      <div className="scrollAlertContainer">
        <div>Scroll for More</div>
        <div className="scrollAlertImage">
          <div className="scrollAlertAnimDiv"></div>
        </div>
      </div>
      <div className="headingAreaMain">
        <h5 className="headingAreaWelcome">— Welcome Back</h5>
        {isEntity ? (
          <Textfit mode="multi" className="headingTitleEntity">
            {entityData["entity"]["entity name"]}
          </Textfit>
        ) : isEmp ? (
          <div className="headingTitleEmp">{empName}</div>
        ) : (
          <div className="headingTitleExec">Abu Dhabi Digital Authority</div>
        )}
        {isEntity === false && isEmp == false && (
          <div className="headingExecInfoContainer">
            <div className="headingSubtitle">
              Leadership Government Level Report
            </div>
            <div className="headingParagraph">{paragraph}</div>
          </div>
        )}
        {isEntity === false && isEmp == false && (
          <div className="headingExecInfoContainer">
            <div className="headingSubtitle">
              Leadership Government Level Report
            </div>
            <div className="headingParagraph">{paragraph}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderCard;
